module.exports = __webpack_public_path__ + "static/media/91B8LqEiEyL._AC_SL1500_.6589dd4e.jpg";